import React from "react";
import GenerateAudioContainer from '../../Containers/GenericContainer/GenerateAudioContainer';
import { Switch, Label } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import './GreetingComponent.css';

export default function GreetingComponent({ callFlowData, setCallFlowData, ACTIVE_TENANT, permissions, isEditMode }) {
    const { t } = useTranslation();

    const messages = [
        { key: "emergencyMessage", label: t("EMERGENCY_MESSAGE") },
        { key: "welcomeMessage", label: t("WELCOME_MESSAGE") },
        { key: "flashMessage", label: t("FLASH_MESSAGE") },
        { key: "customMessage", label: t("CUSTOM_MESSAGE") },
    ];

    const defaultTexts = {
        emergencyMessage: "This is the default emergency message",
        welcomeMessage: "Hello, welcome to the service center by Heedify",
        flashMessage: "This is a flash message",
        customMessage: "",
    };

    const handleUpdateMessage = (key, updates) => {
        const defaultMessage = {
            enabled: false,
            type: "Text2speech",
            language: callFlowData?.language || "en-US",
            text: "",
            audioFileUrl: "",
            selectedMedia: null,
        };

        setCallFlowData({
            ...callFlowData,
            greeting: {
                ...callFlowData.greeting,
                [key]: {
                    ...defaultMessage,
                    ...callFlowData.greeting?.[key],
                    ...updates,
                },
            },
        });
    };

    const renderMessage = (msg) => {
        const messageDataRaw = callFlowData?.greeting?.[msg.key] || {};
        
        // Normaliser le type : text2speech, Text2speech, TEXT2SPEECH -> Text2speech
        let normalizedType = messageDataRaw.type || "Text2speech";
        if (normalizedType.toLowerCase() === "text2speech") {
            normalizedType = "Text2speech";
        } else if (normalizedType.toLowerCase() === "audiofile") {
            normalizedType = "Audiofile";
        }
        
        const messageData = {
            ...messageDataRaw,
            type: normalizedType,
        };
        const displayText = messageData.type === "Text2speech" ? messageData.text || "" : "";

        // 🔐 Vérifier si l'utilisateur peut lire les messages
        if (!permissions?.greeting?.messages?.canRead) {
            return null;
        }

        return (
            <div key={msg.key} className="greeting-message-item">
                <div className="greeting-message-header">
                    <Label weight="semibold">{msg.label}</Label>
                    <Switch
                        checked={messageData.enabled || false}
                        disabled={isEditMode ? !permissions?.greeting?.messages?.canUpdate : !permissions?.greeting?.messages?.canCreate}
                        onChange={(e, data) =>
                            handleUpdateMessage(msg.key, { enabled: data.checked })
                        }
                        className="switch"
                    />
                </div>
                <div className="greeting-message-content">
                    <GenerateAudioContainer
                        text={displayText}
                        type={messageData.type || "Text2speech"}
                        audioFileUrl={messageData.audioFileUrl}
                        fileName={messageData?.selectedMedia?.header || ""}
                        defaultLanguage={messageData.language || callFlowData?.language || "en-US"}
                        disabled={isEditMode ? !permissions?.greeting?.messages?.canUpdate : !permissions?.greeting?.messages?.canCreate}
                        canPlayAudio={permissions?.greeting?.messages?.canRead}
                        autoPlayOnSelect={false}
                        customClassName="greeting-audio"
                        setLangue={(lang) => handleUpdateMessage(msg.key, { language: lang })}
                        setDelete={() =>
                            handleUpdateMessage(msg.key, {
                                audioFileUrl: "",
                                text: "",
                                type: "Text2speech",
                                selectedMedia: null,
                            })
                        }
                        saveAudio={(url) => handleUpdateMessage(msg.key, { audioFileUrl: url })}
                        setText={(text) =>
                            handleUpdateMessage(msg.key, {
                                text,
                                audioFileUrl: "",
                                type: "Text2speech",
                                selectedMedia: null,
                            })
                        }
                        setAudio={(selectedMedia) =>
                            handleUpdateMessage(msg.key, {
                                selectedMedia,
                                audioFileUrl: selectedMedia?.url || "",
                                text: "",
                                type: "Audiofile",
                            })
                        }
                        setType={(type) =>
                            handleUpdateMessage(msg.key, { type })
                        }
                        path={`${ACTIVE_TENANT}/${callFlowData.id}/${msg.key}`}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className="greeting-container">
            <div className="greeting-messages-wrapper">
                {messages.map(renderMessage)}
            </div>
        </div>
    );
}
